import Helpers from './helpers';

const handleCreate = async (setState) => {
  setState.setEditMode('create');
  setState.setRowEditing(null);
  setState.setProviderId(null);
  setState.setOwnerId(null);
  setState.setConsumerId(null);
  setState.setDeviceId(null);
  setState.setName('');
  setState.setDescription('');
  setState.setCron('');

  setState.setEditOpen(true);
};

const handleCreateSubmit = async (values, state, setState, dataStreamFields, postDataStream, schema) => {
  try {
    await Helpers.createDataStream(values, state, setState, dataStreamFields, postDataStream, schema);
  } catch (err) {
    // The mutation's onError has already raised the popup, which sits above the dialog.
    // Swallowed so Formik does not report an unhandled submit rejection, and the dialog is
    // left open so the entered values survive for a retry.
    return;
  }

  setState.setEditOpen(false);
};

const handleDialogOpen = async (event, fieldName, row, setState) => {
  if (fieldName === 'provider_schema') {
    setState.setDialogContent(JSON.stringify(row.provider_schema, undefined, 2));
    setState.setDialogTitle('Provider JSON Schema');
  }
  else if (fieldName === 'provider_properties') {
    setState.setDialogContent(JSON.stringify(row.provider_properties, undefined, 2));
    setState.setDialogTitle('Provider Properties');
  }
  else if (fieldName === 'data_stream_provider_properties') {
    setState.setDialogContent(JSON.stringify(row.data_stream_provider_properties, undefined, 2));
    setState.setDialogTitle('Data Stream Properties');
  }
  setState.setDialogOpen(true);
};

const handleDialogClose = (setState) => {
  setState.setDialogOpen(false);
};

const handleEdit = async (event, row, queryClient, setState) => {
  setState.setEditMode('edit');
  setState.setRowEditing(row);
  setState.setCron(row.cron);
  setState.setLastRetrievalDate(row.last_retrieval_date);
  setState.setProviderId(row.provider_id);
  setState.setOwnerId(row.owner_id);
  // Null for everything but a PC Agent stream, and the dialog only reads it for those.
  setState.setDeviceId(row.device_id ?? null);

  setState.setDataStreamId(row.id);
  await queryClient.refetchQueries('getOwnerConsumerDefaults');

  setState.setEditOpen(true);
};

const handleEditSubmit = async (values, queryClient, state, setState, putDataStream, schema) => {
  // No invalidateQueries here: updateDataStream awaits the PUT, and the mutation's own
  // onSuccess invalidates getDataStreams once the server has the change. Invalidating
  // alongside the request instead raced it, and the grid kept showing the old row.
  try {
    await Helpers.updateDataStream(values, state, putDataStream, schema);
  } catch (err) {
    // The mutation's onError has already raised the popup, which sits above the dialog.
    // Swallowed so Formik does not report an unhandled submit rejection, and the dialog is
    // left open so the edits survive for a retry.
    return;
  }

  setState.setEditOpen(false);
};

const refreshTable = async (queryClient) => {
  await queryClient.invalidateQueries('getDataStreams');
  console.info('Table refreshed');
};


export default {handleCreate, handleCreateSubmit, handleDialogOpen, handleDialogClose, handleEdit, handleEditSubmit,
  refreshTable};

